import { getSortValue, SortOrderType } from 'ted-ui/build/Table';
import { useEffect, useState } from 'react';

/**
 * This custom hook manages the sorting functionality of a table.
 *
 * @returns An object containing the following property:
 *   - sortBy: The accessor name from column config, by this key the data will be sorted
 *   - sortOrder: ['ascending' | 'descending' | 'none'] -> SortOrderType
 *   - onSortFunction: This event occur when sorting happen through sortable column
 *   - sortData: Data after sorting the columns
 */

const useTableSorting = (sortData) => {

    const [sortBy, setSortBy] = useState('');
    const [sortOrder, setSortOrder] = useState<SortOrderType>('none');

    const onSortFunction = (sb: string, so: SortOrderType) => {
        setSortBy(sb);
        setSortOrder(so);
    }

    useEffect(() => {
        if (sortBy && (sortOrder === 'ascending' || sortOrder === 'descending')) {
            sortData = sortData.sort((firstElement, secondElement) => {
                return getSortValue(firstElement[sortBy], secondElement[sortBy], sortOrder);
            });
        }
    }, [sortBy, sortOrder, sortData]);

    return {
        sortBy,
        sortOrder,
        onSortFunction,
        sortData
    }
}

export default useTableSorting;
